import React from "react";
import { useTranslation } from "react-i18next";
import { IonIcon } from "@ionic/react";
import { documentOutline, peopleOutline } from "ionicons/icons";
import "./CommunityStats.css";

const CommunityStats = ({
  postCount = 0,
  memberCount = 0,
  className = "",
  columns = false,
  hidePostsNumber = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={`community-stats ${className} ${columns ? "community-stats-columns" : ""}`}
    >
      {!hidePostsNumber ? (
        <span className="community-stat">
          <IonIcon
            icon={documentOutline}
            style={{
              marginRight: "4px",
              fontSize: "1rem",
              verticalAlign: "text-bottom",
            }}
          />
          <span className="community-stat-value">{postCount}</span>{" "}
          {postCount === 1 ? t("post") : t("posts")}
        </span>
      ) : null}
      <span className="community-stat">
        <IonIcon
          icon={peopleOutline}
          style={{
            marginRight: "4px",
            fontSize: "1rem",
            verticalAlign: "text-bottom",
          }}
        />
        <span className="community-stat-value">{memberCount}</span>{" "}
        {memberCount === 1 ? t("member") : t("members")}
      </span>
    </div>
  );
};

export default CommunityStats;

